import React from "react";

export default function ShortTextIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      enableBackground='new 0 0 24 24'
      height='24px'
      viewBox='0 0 24 24'
      width='24px'
      fill='#898989'
    >
      <g>
        <rect fill='none' height='24' width='24' x='0' />
      </g>
      <g>
        <g>
          <g>
            <path d='M4,9h16v2H4V9z M4,13h10v2H4V13z' />
          </g>
        </g>
      </g>
    </svg>
  );
}
